<template>
  <div class="card-pedido-final">
    <g-card
    :temCabecalho = "false"
    >
      <div class="header-card-pedido-final espacamento-header-resumo-final">
        <div class="pedidoFinal-imagem">
          <img class="card-proposta-img" src="@/assets/imgs/caixa.png"/>
        </div>

        <div class="titulo-resumo-final"> PEDIDO <div class="container-numero">#<div class="cor-numero">{{PedidoArray.codigoExterno}}</div></div> </div>
        <div class="subtitulo-resumo-final"> SEU PEDIDO FOI CRIADO COM SUCESSO! </div>

        <div class="linha-separacao"></div>

        <div class="unidade-representante">
          <div class="titulo-conteudo-cabecalho"> Representante: &nbsp;<div class="label-cabecalho"> {{PedidoArray.nomeRepresentante}} </div></div>
          <div class="titulo-conteudo-cabecalho"> Empresa: &nbsp;<div class="label-cabecalho"> {{PedidoArray.nome}} </div></div>
        </div>

        <div class="header-icons">
          <g-button
          class="botoes"
          altura="36px"
          largura="38px"
          tamanhoIcone="18px"
          icone="icone_compartilhar.svg"
          >
          </g-button>

          <g-button
          @click="pdfFinal()"
          class="botoes"
          altura="36px"
          largura="38px"
          tamanhoIcone="18px"
          icone="icone_print.svg"
          >
          </g-button>
        </div>
      </div>

      <!-- <g-pdf :pdfFloat="false" :NovaGuia="true"  :executar="executarvisualizacao">
          <div class="render" v-if="renderiza">
              <PDFPedidoFinal :tituloDetalhes="false" v-on:termino="gerarPdf" :PedidoId="PedidoId"></PDFPedidoFinal>
          </div>
      </g-pdf> -->

      <g-pdf :pdfFloat="false" :NovaGuia="true" :executar="executarvisualizacao">
        <div class="render" v-if="renderiza">
          <PedidoEmAndamentoPDF :tituloDetalhes="false" v-on:termino="gerarPdf" :pedidoSelecionado="PedidoId"></PedidoEmAndamentoPDF>
        </div>
      </g-pdf>

      <div class="espacamento-resumo-final">
        <div class="titulo-grupo-detalhes"> ORÇAMENTO </div>
        <div class="grupo-orcamento">
          <div class="orcamento-numero-solicitacao">
            <div class="titulo-conteudo-resumo-final"> Nº Solicitação </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.numeroDaSolicitacao}} </div>
          </div>

          <div class="orcamento-data-digitacao">
            <div class="titulo-conteudo-resumo-final"> Dt. de Digitação </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.dataDigitacaoFormatada}} </div>
          </div>

          <div class="orcamento-razao-social">
              <div class="titulo-conteudo-resumo-final"> Razão Social </div>
              <div class="label-conteudo-resumo-final"> {{PedidoArray.razaoSocialCliente}} </div>
          </div>

          <div class="orcamento-nome-produto">
              <div class="titulo-conteudo-resumo-final"> Nome do Produto do Orçamento </div>
              <div class="label-conteudo-resumo-final"> {{PedidoArray.codigoExternoProdutoNovo}} - {{PedidoArray.nomeProduto}} </div>
          </div>

          <div class="orcamento-status">
            <div class="titulo-conteudo-resumo-final"> Status </div>
              <div class="label-conteudo-resumo-final"> {{PedidoArray.statusPedidoTexto}} </div>
          </div>

          <div class="orcamento-cliente">
              <div class="titulo-conteudo-resumo-final"> Cliente </div>
              <div class="label-conteudo-resumo-final"> {{PedidoArray.nomeFantasia}} </div>
          </div>

          <div class="orcamento-unidade">
              <div class="titulo-conteudo-resumo-final"> Unidade </div>
              <div class="label-conteudo-resumo-final"> {{PedidoArray.nome}} </div>
          </div>

          <div class="orcamento-representante">
              <div class="titulo-conteudo-resumo-final"> Representante </div>
              <div class="label-conteudo-resumo-final"> {{PedidoArray.nomeRepresentante}} </div>
          </div>
        </div>

        <div class="titulo-grupo-detalhes"> CLIENTE </div>
        <div class="grupo-cliente">
          <div class="cliente-cnpj">
            <div class="titulo-conteudo-resumo-final"> CNPJ </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.cnpj}} </div>
          </div>

          <div class="cliente-codigo">
            <div class="titulo-conteudo-resumo-final"> Código </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.codigoExt}} </div>
          </div>

          <div class="cliente-razao-social">
            <div class="titulo-conteudo-resumo-final"> Razão Social</div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.razaoSocialCliente}} </div>
          </div>

          <div class="cliente-estado">
            <div class="titulo-conteudo-resumo-final"> Estado </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.nomeEstado}} </div>
          </div>

          <div class="cliente-cidade">
            <div class="titulo-conteudo-resumo-final"> Cidade </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.nomeCidade}} </div>
          </div>

          <div class="cliente-segmento">
            <div class="titulo-conteudo-resumo-final"> Segmento </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.segmento}} </div>
          </div>

          <div class="cliente-contato">
            <div class="titulo-conteudo-resumo-final"> Contato </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.emailNFE}} </div>
          </div>

          <div class="cliente-telefone">
            <div class="titulo-conteudo-resumo-final"> Telefone </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.numeroTelefone}} </div>
          </div>

          <div class="cliente-ramal">
            <div class="titulo-conteudo-resumo-final"> Ramal </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.numeroDDDFax}} </div>
          </div>

          <div class="cliente-suframa">
            <div class="titulo-conteudo-resumo-final"> Suframa </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.numeroSuframa}} </div>
          </div>

          <div class="cliente-incentivo-fiscal">
            <div class="titulo-conteudo-resumo-final"> Possui incentivo fiscal? </div>
            <div class="label-conteudo-resumo-final"> ICMS: {{ PedidoArray.getICMS }} - IPI: {{ PedidoArray.getIPI }} - Pis/Cofins: {{ PedidoArray.getPisCofins }} </div>
          </div>
        </div>

        <div class="titulo-grupo-detalhes"> FRETE </div>
        <div class="grupo-frete">
          <div class="grupoFrete-frete">
            <div class="titulo-conteudo-resumo-final"> Frete </div>
            <div class="label-conteudo-resumo-final"> {{PedidoFreteArray.indicadorDeTipoFreteoEnum}} </div>
          </div>

          <div class="frete-estado">
            <div class="titulo-conteudo-resumo-final"> Estado </div>
            <div class="label-conteudo-resumo-final"> {{PedidoFreteArray.nomeEstado}} </div>
          </div>

          <div class="frete-cidade">
            <div class="titulo-conteudo-resumo-final"> Cidade </div>
            <div class="label-conteudo-resumo-final"> {{PedidoFreteArray.nomeCidade}} </div>
          </div>

          <div class="frete-transportadora">
            <div class="titulo-conteudo-resumo-final"> Transportadora </div>
            <div class="label-conteudo-resumo-final"> {{PedidoFreteArray.nomeTransportadora || 'NÃO CADASTRADO'}} </div>
          </div>

          <div class="frete-endereco">
            <div class="titulo-conteudo-resumo-final"> Endereço </div>
            <div class="label-conteudo-resumo-final"> {{PedidoFreteArray.nomeEndereco}} </div>
          </div>

          <div class="frete-cep">
            <div class="titulo-conteudo-resumo-final"> CEP </div>
            <div class="label-conteudo-resumo-final"> {{PedidoFreteArray.cep}} </div>
          </div>

          <div class="frete-bairro">
            <div class="titulo-conteudo-resumo-final"> Bairro </div>
            <div class="label-conteudo-resumo-final"> {{PedidoFreteArray.bairro}} </div>
          </div>

          <div class="frete-complemento">
            <div class="titulo-conteudo-resumo-final"> Complemento </div>
            <div class="label-conteudo-resumo-final"> {{PedidoFreteArray.complemento}} </div>
          </div>
        </div>

        <div class="titulo-grupo-detalhes"> PRODUTO </div>
        <div class="grupo-produto">
          <div class="grupoProduto-produto">
            <div class="titulo-conteudo-resumo-final"> Produto </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.codigoExternoProdutoNovo}} - {{PedidoArray.nomeProduto}} </div>
          </div>

          <div class="grupoProduto-codigo-produto">

          </div>

          <!-- <div class="produto-tipo-acesso">
            <div class="titulo-conteudo-resumo-final"> Tipo de Acesso </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.codigoAcesso}} </div>
          </div> -->

          <div class="produto-condicao-pagamento">
            <div class="titulo-conteudo-resumo-final"> Condição de Pagamento </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.formaDePagamento}} </div>
          </div>

          <div class="produto-quantidade-total">
            <div class="titulo-conteudo-resumo-final"> Quantidade Total </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.quantidadeProdutoNovo}} </div>
          </div>

          <div class="produto-unitario">
            <div class="titulo-conteudo-resumo-final"> Unitário </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.valorUnitario}} </div>
          </div>

          <div class="produto-preco-total">
            <div class="titulo-conteudo-resumo-final"> Preço Total sem IPI </div>
            <div class="label-conteudo-resumo-final"> {{PedidoArray.precoTotalSemIPIFormatado}} </div>
          </div>

          <!-- <div class="produto-complemento">
            <div class="titulo-conteudo-resumo-final"> Complemento </div>
            <div class="label-conteudo-resumo-final"> N/A </div>
          </div> -->
        </div>
        <div class="titulo-grupo-detalhes"> PARCELA(S) </div>
        <div class="vfor-quantidadeParcela" :key="parcela.id" v-for="parcela in quantidadeParcelaArray">
          <div class="grupoProduto-numero-parcela">
            <div class="titulo-conteudo-resumo-final">Parcela</div>
            <div class="label-conteudo-resumo-final"> {{parcela.numeroParcela}} </div>
          </div>

          <div class="grupoProduto-data-entrega">
            <div class="titulo-conteudo-resumo-final"> Data de Entrega </div>
            <div class="label-conteudo-resumo-final"> {{parcela.dataPedidoParcelaFormatada}} </div>
          </div>
          <div class="grupoProduto-data-entrega">
            <div class="titulo-conteudo-resumo-final"> Quantidade </div>
            <div class="label-conteudo-resumo-final"> {{parcela.quantidadePedidoParcela}} </div>
          </div>
        </div>
      </div>

      <div class="buttons-next-back">
        <div class="button-next">
          <g-button 
          tipo="amarelo"
          altura="35px"
          largura="100%"
          negritoTexto 
          @click="novoPedido()"
          > 
            NOVO PEDIDO 
          </g-button>
        </div>
        <div class="button-back">
          <g-button 
          tipo="cinza" 
          altura="35px"
          largura="100%"
          negritoTexto 
          @click="consultarpedidos()"
          > 
            VER PEDIDOS 
          </g-button>
        </div>
      </div>
    </g-card>
  </div>




  <PDialog :closable="false" :showHeader=false v-model:visible="PopupTemSequenciaAinda" :modal="true">
    <div class="titulo-popup-finalizado"> Pedido #{{PedidoArray.codigoExterno}}  incluido com sucesso
      <br> 
      <br> 
      Existem sequências deste orçamento a serem digitadas.
      <br> 
      <br> 
    </div>


    <div class="botoes-popup">
      <div>
        <g-button
        tipo="cinza"
        negritoTexto 
        largura="200px" 
        altura="45px" 
        @click="this.$router.push(`/resumo-sequencia/${this.PedidoArray.orcamentoId}`);"
        >
        DIGITAR OUTRO PEDIDO
        </g-button>
      </div>
      <div>
        <g-button
        negritoTexto
        largura="200px" 
        altura="45px" 
        @click="PopupTemSequenciaAinda= false"
        >
        FECHAR
        </g-button>
      </div>
    </div>
  </PDialog>

</template>

<script>
import PedidoFinal from './PedidoFinal.js'
export default PedidoFinal
</script>

<style scoped>
.vfor-quantidadeParcela {
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 20px;
  grid-row-gap: 0px;
}
.cor-numero{
  color: #fcb316;
    font-family: "MontSerrat";
    font-weight: 700;
}

.header-icons {
    justify-content: end;
}

.subtitulo-resumo-final, .pedidoFinal-representante, .pedidoFinal-unidade {
  color:#4F4C4D;
  font-family: 'MontSerrat';
  font-weight: bold;
  text-align: left;
  display: flex;
}

.representante-conteudo, .unidade-conteudo {
  color: #3E3E3E;
  font-family: 'MontSerrat';
  text-align: left;
  font-weight: 500;
}

.topico {
  padding-bottom: 20px;
}

.grupo {
  color: #4f2c19;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: bold;
  margin-top: 30px;
  display: flex;
}

.titulo {
  color: #3E3E3E;
  text-align: left;
  font-family: "MontSerrat";
  font-weight: 500;
  margin-top: 15px;
}

.conteudo {
  color: #8A8A8A;
  text-align: left;
  font-family: "MontSerrat";
  margin-bottom: 10px;
}


@media (min-width:310px) {
  .container-numero{
    display: flex;
    justify-content: center;
  }
  
.header-card-pedido-final {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 1fr));
  grid-template-rows: repeat(6, auto);
  grid-column-gap: 20px;
  grid-row-gap: 10px;
}

.pedidoFinal-imagem { grid-area: 2 / 1 / 4 / 3; }
.titulo-resumo-final { grid-area: 4 / 1 / 5 / 3; text-align: center; flex-wrap: wrap;}
.subtitulo-resumo-final { display: none; }
.unidade-representante { grid-area: 6 / 1 / 7 / 3; }
.header-icons { grid-area: 1 / 1 / 2 / 3; }
.linha-separacao { grid-area: 5 / 1 / 6 / 3; margin: 10px 0 5px; }

.representante-conteudo, .unidade-conteudo { font-size: 15px; }

.card-proposta-img { height: 6em; }

.topico{
  display: flex;
  flex-wrap: wrap;
  column-gap: 15%;
}

.grupo { font-size: 18px; }

.btnPedido {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  column-gap: 50px;
  row-gap: 15px;
  margin-top: 50px;
}
}


@media (min-width:368px) {
}

@media (min-width:400px) {
  .grupo-orcamento{
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(7, auto);
    grid-column-gap: 20px;
  }
}

@media (min-width:500px){
  .container-numero{
    display: flex;
    justify-content: left;
  }
  .grupo-cliente{
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(6, auto);
    column-gap: 3%;
  }
  .grupo-frete{
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
    column-gap: 3%;
  }
  .grupo-produto{
    display: grid;
    grid-template-columns: repeat(2, minmax(4em, 1fr));
    grid-template-rows: repeat(3, auto);
    column-gap: 3%;
  }
  .header-card-pedido-final {
    grid-template-columns: 0.3fr 1fr 0.3fr;
    grid-template-rows: repeat(3, auto);
  }
  .pedidoFinal-imagem { grid-area: 1 / 1 / 2 / 2; justify-self: self-start; }
  .titulo-resumo-final { grid-area: 1 / 2 / 2 / 3; display: flex;}
  .card-proposta-img { height: 4.5em; }
  .linha-separacao { grid-area: 2 / 1 / 3 / 4; }
  .unidade-representante { grid-area: 3 / 1 / 4 / 4; }
  .header-icons { grid-area: 1 / 3 / 2 / 4; }
}

@media (min-width:600px) {
  .grupo-orcamento{
    display: grid;
    grid-template-columns: repeat(3, minmax(4em, 1fr));
    grid-template-rows: repeat(3, auto);
    grid-column-gap: 20px;
  }

.representante-conteudo, .unidade-conteudo { font-size: 16px; }

.card-proposta-img { height: 5em; }
}


@media (min-width:801px) {
  .grupo-cliente{
    display: grid;
    grid-template-columns: repeat(3, minmax(4em, 1fr));
    grid-template-rows: repeat(4, auto);
    column-gap: 3%;
  }
  .grupo-frete{
    display: grid;
    grid-template-columns: repeat(3, minmax(4em, 1fr));
    grid-template-rows: repeat(3, auto);
    column-gap: 3%;
  }
  .grupo-produto{
    display: grid;
    grid-template-columns: repeat(3, minmax(4em, 1fr));
    grid-template-rows: repeat(3, auto);
    column-gap: 3%;
  }
  .header-card-pedido-final {
    display: grid;
    grid-template-columns: repeat(2, 0.8fr) repeat(2, minmax(4em, 7.5fr)) repeat(2, 1.5fr);
    grid-template-rows: repeat(4, auto);
    grid-column-gap: 20px;
    grid-row-gap: 0px;
  }

  .conteudo-card-pedido-final {
    padding: 0 30px;
  }

  .pedidoFinal-imagem { grid-area: 1 / 1 / 3 / 3; }
  .titulo-resumo-final {
    grid-area: 1 / 3 / 2 / 5; text-align: left;
  }
  .subtitulo-resumo-final {
    grid-area: 2 / 3 / 3 / 5; display: block;
  }
  .unidade-representante { grid-area: 4 / 1 / 5 / 7; }
  .linha-separacao { grid-area: 3 / 1 / 4 / 7; margin: 15px 0 10px; }
  .header-icons { grid-area: 1 / 5 / 2 / 7; }
}


@media (min-width:1025px) {
  .grupo-orcamento{
    display: grid;
    grid-template-columns: repeat(4, minmax(4em, 1fr));
    grid-template-rows: repeat(2, auto);
    grid-column-gap: 20px;
  }
  .grupo-cliente{
    display: grid;
    grid-template-columns: repeat(4, minmax(4em, 1fr));
    grid-template-rows: repeat(3, auto);
    column-gap: 3%;
  }
  .grupo-frete{
    display: grid;
    grid-template-columns: repeat(4, minmax(4em, 1fr));
    grid-template-rows: repeat(2, auto);
    column-gap: 3%;
  }
  .grupo-produto{
    display: grid;
    grid-template-columns: repeat(4, minmax(4em, 1fr));
    grid-template-rows: repeat(2, auto);
    column-gap: 3%;
  }
  .header-card-pedido-final {
    grid-template-columns: repeat(2, 0.6fr) repeat(2, minmax(4em, 4.4fr)) repeat(2, 3fr);
    grid-template-rows: repeat(2, auto);
    grid-row-gap: 10px;
  }

  .conteudo-card-pedido-final {
    padding: 0 50px;
  }
  .unidade-representante { grid-area: 2 / 5 / 3 / 7; justify-self: flex-end; }

  .representante-conteudo, .unidade-conteudo { font-size: 16px; }

  .topico{
    border-bottom: none;
    border-top: 1px solid #e1e1e1;
    margin-top: 10px;
    column-gap: 6%;
  }
  .linha-separacao { display: none; }

  .grupo { font-size: 19px; }
}


@media (min-width:1281px) {
  .grupo-orcamento{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 3%;
  }
  .grupo-cliente{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 3%;
  }
  .grupo-frete{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 3%;
  }
  .grupo-produto{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 3%;
  }
}

@media (min-width:1400px) {
  .header-card-pedido-final {
    grid-template-columns: repeat(2, 0.4fr) repeat(2, minmax(4em, 4.4fr)) repeat(2, 3fr);
  }
}

@media (min-width:1500px){
  .grupo-orcamento{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 3%;
  }

  .grupo-cliente{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 3%;
  }
  .grupo-frete{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 3%;
  }
  .grupo-produto{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 3%;
  }
  .card-proposta-img { height: 5.5em; }
}

@media (min-width:1800px){
}

@media (min-width:2000px){
  .header-card-pedido-final {
    grid-template-columns: repeat(2, 0.4fr) repeat(2, minmax(4em, 5fr)) repeat(2, 3fr);
    grid-template-rows: auto;
  }
  .card-proposta-img { height: 6.5em; }
}

@media (min-width:2500px){
  .card-proposta-img { height: 6.5em; }
}
</style>